import { Component, OnInit } from '@angular/core';
import { RobotRulesService } from '../robot-rules.service';
import _ from 'lodash';

@Component({
  selector: 'host-test-rule',
  templateUrl: './test-rule.component.html',
  styleUrls: ['./test-rule.component.scss'],
})
export class TestRuleComponent implements OnInit {
  question;
  intent;

  constructor(private robotRulesService: RobotRulesService) {}

  ngOnInit() {}

  testRule() {
    this.robotRulesService.requestTestRule({ message: this.question }).subscribe((res) => {
      console.log('intent: ', res);
      this.intent = _.get(res, 'data.intent.description');
    });
  }
}
